import { adminApi } from './admin-api';
import type { AdminActivityFeedResponse, AdminFilters, ServiceHealthResponse, SystemMetricsResponse, LogEntry, BrowserInstance, CronJobsResponse, PaginatedResponse } from '@/types/admin.types';

export const adminMonitoringService = {
  getHealth: async (): Promise<ServiceHealthResponse> => {
    const response = await adminApi.get('/admin/monitoring/health');
    return response.data;
  },

  getMetrics: async (): Promise<SystemMetricsResponse> => {
    const response = await adminApi.get('/admin/monitoring/metrics');
    return response.data;
  },

  getLogs: async (filters: AdminFilters & { level?: string; context?: string } = {}): Promise<PaginatedResponse<LogEntry>> => {
    const params = new URLSearchParams();
    if (filters.page) params.set('page', String(filters.page));
    if (filters.limit) params.set('limit', String(filters.limit));
    if (filters.search) params.set('search', filters.search);
    if (filters.level) params.set('level', filters.level);
    if (filters.context) params.set('context', filters.context);
    if (filters.dateFrom) params.set('dateFrom', filters.dateFrom);
    if (filters.dateTo) params.set('dateTo', filters.dateTo);
    const response = await adminApi.get(`/admin/monitoring/logs?${params.toString()}`);
    return response.data;
  },

  getBrowserPool: async (): Promise<BrowserInstance[]> => {
    const response = await adminApi.get('/admin/monitoring/browser-pool');
    return response.data;
  },

  restartBrowserInstance: async (id: string): Promise<{ message: string }> => {
    const response = await adminApi.post(`/admin/monitoring/browser-pool/${id}/restart`);
    return response.data;
  },

  getCronJobs: async (): Promise<CronJobsResponse> => {
    const response = await adminApi.get('/admin/monitoring/cron-jobs');
    return response.data;
  },

  getDashboardStats: async () => {
    const response = await adminApi.get('/admin/dashboard/stats');
    return response.data;
  },

  getActivityFeed: async (): Promise<AdminActivityFeedResponse> => {
    const response = await adminApi.get('/admin/dashboard/activity-feed');
    const activities = Array.isArray(response.data?.activities)
      ? response.data.activities
      : [];
    return { activities };
  },

  getSystemAlerts: async () => {
    const response = await adminApi.get('/admin/dashboard/alerts');
    return response.data;
  },

  getApiLatency: async () => {
    const response = await adminApi.get('/admin/monitoring/api-latency');
    return response.data;
  },

  getErrorRate: async () => {
    const response = await adminApi.get('/admin/monitoring/error-rate');
    return response.data;
  },
};
